import {
  CodeInput,
  CodeInputSubmitHandler,
  copyToClipboard,
  DataStatus,
  IconButton,
  Label,
  Separator,
} from 'platform/components';
import {Box, HStack, Image, Text, VStack} from 'platform/foundation';

import {
  useGetMultiFactorAuthenticationTotpGenerateQuery,
  useVerifyMultiFactorAuthenticationTotpMutation,
} from '@dms/api/base';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {ApiError} from 'shared/web';

export function PairAuthDevice() {
  const {
    data: generatedMfa,
    isLoading: isGeneratedMfaLoading,
    isError: isGeneratedMfaError,
  } = useGetMultiFactorAuthenticationTotpGenerateQuery();

  const [verifyCode, {isLoading: isVerifying}] = useVerifyMultiFactorAuthenticationTotpMutation();

  const handleVerifyCode: CodeInputSubmitHandler = (inputCode, {resetField}) =>
    verifyCode({code: inputCode.join('')})
      .unwrap()
      .catch((err: ApiError) => {
        handleApiError(err);
        resetField();
      });

  return (
    <Box>
      <VStack align="flex-start">
        <Text color="secondary" size="small">
          {i18n.t('page.myProfile.labels.multiFactorAuthDescriptionLine')}
        </Text>
        <Box paddingLeft={2}>
          <Text color="secondary" size="small">
            {i18n.t('page.myProfile.labels.multiFactorAuthDescriptionLine1')}
          </Text>
        </Box>
        <Box paddingLeft={2}>
          <Text color="secondary" size="small">
            {i18n.t('page.myProfile.labels.multiFactorAuthDescriptionLine2')}
          </Text>
        </Box>
      </VStack>

      <Box maxWidth={200}>
        <DataStatus isLoading={isGeneratedMfaLoading} isError={isGeneratedMfaError} minHeight={40}>
          <VStack align="flex-start" width="100%">
            <VStack align="center">
              <Image
                src={`data:image/png;base64,${generatedMfa?.barcode}`}
                width={60}
                height={60}
              />

              <VStack>
                <Label>{i18n.t('general.labels.secret')}</Label>
                <HStack spacing={2} align="center">
                  <IconButton
                    size="small"
                    severity="informational"
                    onClick={() => copyToClipboard(generatedMfa?.secret ?? '')}
                    icon="content/copy"
                  />
                  <Text size="xSmall" noWrap>
                    {generatedMfa?.secret}
                  </Text>
                </HStack>
              </VStack>
            </VStack>
          </VStack>

          <Box width="100%">
            <Separator />
          </Box>

          <Box paddingBottom={4}>
            <CodeInput
              length={6}
              onSubmit={handleVerifyCode}
              isAutoFocused
              isRequired
              isDisabled={isVerifying}
              label={i18n.t('page.myProfile.labels.multiFactorAuthCode')}
            />
          </Box>
        </DataStatus>
      </Box>
    </Box>
  );
}
